import {USER_ERROR, USER_FB_TOKEN_REQUEST, USER_FB_TOKEN_SUCCESS, USER_REQUEST, USER_SUCCESS} from '../actions/user'
import Vue from 'vue'
import {AUTH_LOGOUT} from '../actions/auth'
import AuthService from "../../services/AuthService";
import {defineAbilitiesFor} from "../../util/abilities";


const state = {status: '', user: {}, fbToken: ''};

const getters = {
    getUser: state => state.user,
    isUserLoaded: state => !!state.user.name,
    isUserSuccess: state => state.status === 'success',
    isHotel: state => state.user ? state.user.profile === 'HOTEL' : false,
    getFbToken: state => state.fbToken
};

const actions = {
    [USER_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(USER_REQUEST);
            AuthService.authInfo()
                .then(resp => {
                    if (resp) {
                        const payload = resp.data.payload;
                        window.dispatchEvent(new Event('resize'));
                        defineAbilitiesFor(payload.profile);
                        commit(USER_SUCCESS, payload);
                        resolve();
                    } else {
                        commit(USER_ERROR);
                        dispatch(AUTH_LOGOUT);
                    }
                })
                .catch(err => {
                    commit(USER_ERROR);
                    dispatch(AUTH_LOGOUT);
                    reject(err);
                });
        });
    },
    [USER_FB_TOKEN_REQUEST]: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit(USER_REQUEST);
            AuthService.fbCustomToken()
                .then(resp => {
                    commit(USER_FB_TOKEN_SUCCESS, resp.data.payload.accessToken);
                    resolve(resp.data.payload.accessToken);
                })
                .catch(err => {
                    console.error(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [USER_SUCCESS]: (state, resp) => {
        state.status = 'success';
        Vue.set(state, 'user', resp)
    },
    [USER_ERROR]: (state) => {
        state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
        state.user = {}
    },
    [USER_FB_TOKEN_SUCCESS]: (state, token) => {
        Vue.set(state, 'fbToken', token)
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js